import styled, { css } from 'styled-components'

import { Icon } from '@/components/ui/icon'

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const AccordionButton = styled.button(
  ({ theme }) => css`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    font-weight: bold;
    background: none;
    border: none;
    outline: none;
    color: ${({ theme }) => theme.colors.black800};
    cursor: pointer;
    padding: 0;
    margin: 0;
    border-radius: unset;
    user-select: none;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${theme.border.size['1']};
    }
  `,
)

export const AccordionIcon = styled(Icon)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => css`
    margin-left: auto;
    color: ${theme.colors.black300};
    transform: rotate(${$isOpen ? '180deg' : '0deg'});
    transition: transform ${theme.transition.duration.md} ease;
  `,
)

export const AccordionContent = styled.div`
  overflow: hidden;
  will-change: max-height;
  transition: max-height ${({ theme }) => theme.transition.duration.md} ease;
`
